import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Status } from "core/models/error";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			staleTime: 600000, // 10 min
			retry: false,
			throwOnError: (e) => {
				if (e.type === Status[400] || e.type === Status[404]) return false;
				else return true;
			}
		}
	}
});

export const getContext = () => ({ queryClient, user: undefined });

export default function QueryProvider({ children }) {
	return (
		<QueryClientProvider client={queryClient}>
			{children}
		</QueryClientProvider>
	);
}